import * as FuncionesFecha from "../../funciones/FuncionesFecha.js";

export const ItemVacio = (idPadre) => {
  return {
    id: null,
    idPersona: idPadre,
    boletin: null,
    tipoPaseBoletin: null,
    fechaHasta: null,
    tipoObjetoOrigen: null,
    idOrigen: null,
    tipoObjetoDestino: null,
    idDestino: null,
    observacion: "",
    dudas: "",
  };
};

export const saveItem = (item) => {
  // Map to API expected shape. If API requires different fields adapt later.
  // Normalize fechaHasta to FechaBase (yyyy-mm-dd) when possible
  let fechaHasta = null;
  if (item.fechaHasta) {
    if (FuncionesFecha.EsDate(item.fechaHasta)) {
      fechaHasta = FuncionesFecha.DateToFechaBase(item.fechaHasta);
    } else if (FuncionesFecha.EsFechaValida(item.fechaHasta)) {
      // If already in yyyy-mm-dd keep it, otherwise try parse dd/mm/yyyy
      const isoRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (isoRegex.test(item.fechaHasta)) {
        fechaHasta = item.fechaHasta;
      } else {
        const d = FuncionesFecha.FechaCortaToDate(item.fechaHasta);
        fechaHasta = FuncionesFecha.DateToFechaBase(d);
      }
    } else {
      // fallback: send as-is
      fechaHasta = item.fechaHasta;
    }
  }

  return {
    id: item.id,
    idPersona: item.idPersona,
    idBoletin: item.boletin && item.boletin.id,
    codTipoPaseBoletin: item.tipoPaseBoletin && item.tipoPaseBoletin.codigo,
    fechaHasta: fechaHasta,
    codTipoObjetoOrigen: item.tipoObjetoOrigen && item.tipoObjetoOrigen.codigo,
    idOrigen: item.idOrigen ? item.idOrigen : item.origen && item.origen.id,
    codTipoObjetoDestino:
      item.tipoObjetoDestino && item.tipoObjetoDestino.codigo,
    idDestino: item.idDestino
      ? item.idDestino
      : item.destino && item.destino.id,
    observacion: item.observacion,
    dudas: item.dudas,
  };
};
